import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgPlayIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="20"
        width="19"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 19 20"
    >
        <path
            d="M9.00049 2.16797C13.3259 2.16812 16.8315 5.67445 16.8315 10L16.8218 10.4033C16.6118 14.5412 13.1906 17.8309 9.00049 17.8311L8.59717 17.8213C4.45904 17.6114 1.1686 14.1901 1.16846 10L1.17822 9.59668C1.38137 5.59211 4.5926 2.38088 8.59717 2.17773L9.00049 2.16797Z"
            fill="none"
            stroke="#715AFF"
            stroke-width="1.3"
        />
        <path
            d="M7.15039 6.89258C7.15039 6.61106 7.46595 6.44441 7.69824 6.60352L12.2285 9.70605C12.4313 9.84519 12.4313 10.1453 12.2285 10.2842L7.71973 13.3711L7.6416 13.417C7.42004 13.5196 7.1506 13.3564 7.15039 13.0977V6.89258Z"
            fill="none"
            stroke="#715AFF"
            stroke-width="1.3"
        />
    </svg>
);

export const PlayIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgPlayIcon}
        fontSize={fontSize}
    />
);
